import React from 'react'

import EventListItem from './EventListItem'
import EventsEmptyState from './EventsEmptyState'

const EventsIndexView = ({ events, emptyLabel }) => {
  if (!events.length) return <EventsEmptyState type={emptyLabel} />

  return (
    <div>
      {events.map(event => (
        <EventListItem key={`${event.type}-${event.id}`} event={event} />
      ))}
    </div>
  )
}

EventsIndexView.propTypes = {
  events: React.PropTypes.array.isRequired,
  emptyLabel: React.PropTypes.string
}

export default EventsIndexView
